var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"py-8 px-6",attrs:{"fluid":""}},[_c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('v-card',{attrs:{"flat":"","outlined":""}},[_c('v-subheader',[_vm._v("Ordrar som väntar på kund")]),_c('order-panels',{attrs:{"orders":_vm.changeRequestedOrders}})],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }